<template>
    <CModal
        title="Pengajuan Pembatalan RPL"
        :show.sync="modalDetailPembatalan"
        :no-close-on-backdrop="true"
        :centered="true"
    >
        <template #header>
            <h6 class="modal-title h5 font-weight-bold">Detail Pembatalan</h6>
        </template>
        <CRow>
            <div class="modal-body row my-n3">
                <table class="table">
                    <tr>
                        <th class="w-50">Nama Anggota</th>
                        <td>:</td>
                        <td>{{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>Nama Pelatihan</th>
                        <td>:</td>
                        <td>{{ formData.nama_pelatihan ? formData.nama_pelatihan : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>Kategori Anggota</th>
                        <td>:</td>
                        <td>{{ formData.nama_kategori ? formData.nama_kategori : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>No. Handphone</th>
                        <td>:</td>
                        <td>{{ formData.no_handphone ? formData.no_handphone : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>No. Telepon</th>
                        <td>:</td>
                        <td>{{ formData.no_telephone ? formData.no_telephone : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td>:</td>
                        <td>{{ formData.email ? formData.email : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>Bank</th>
                        <td>:</td>
                        <td>{{ formData.nama_bank ? formData.nama_bank : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>Nama Rekening</th>
                        <td>:</td>
                        <td>{{ formData.nama_rekening ? formData.nama_rekening : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>No. Rekening</th>
                        <td>:</td>
                        <td>{{ formData.no_rekening ? formData.no_rekening : ' - ' }}</td>
                    </tr>
                    <tr>
                        <th>Bukti Refund</th>
                        <td>:</td>
                        <td>
                            <button 
                            :class="formData.file_bukti_refund === null ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-success'" 
                            :disabled="formData.file_bukti_refund === null" 
                            @click="lihatFile(formData.file_bukti_refund)">
                            Lihat File
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th>Status Approval Keuangan</th>
                        <td>:</td>
                        <td>
                            <span class="text-success font-weight-bold" v-if="formData.status_approval_keuangan == '1' ">Disetujui</span>
                            <span class="text-danger font-weight-bold" v-else-if="formData.status_approval_keuangan == '0'">Ditolak</span>
                            <span class="text-warning font-weight-bold" v-else>Menunggu</span>
                        </td>
                    </tr>
                </table>
                <div class="col-12">
                    <div class="form-group">
                        <label for="" class="font-weight-bold">Alasan</label>
                        <textarea  
                        class="form-control"
                            cols="30"
                            readonly
                            v-model="formData.alasan_batal" 
                            rows="5">
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label for class="font-weight-bold">Status</label>
                        <div class="d-flex align-items-center">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"
                                name="customRadioPembatalan"
                                id="aktif_pembatalan"
                                value="Disetujui"
                                :disabled="formData.status_approval_keuangan == null || formData.status_approval_keuangan == '0'"
                                v-model="formData.statusbatal"
                            />
                            <label class="custom-control-label" for="aktif_pembatalan">Disetujui</label>
                        </div>
                     
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"
                                name="customRadioPembatalan"
                                id="tidak_aktif_pembatalan"
                                :disabled="formData.status_approval_keuangan == null || formData.status_approval_keuangan == '0'"
                                v-model="formData.statusbatal"
                                value="Ditolak"
                            />
                            <label class="custom-control-label" for="tidak_aktif_pembatalan">Ditolak</label>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </CRow>
        <template #footer>
            <CButton @click="modalDetailPembatalan = false" color="danger">Tutup</CButton>
            <CButton color="info" @click="postStatusPembatalan" :disabled="formData.status_approval_keuangan == null || formData.status_approval_keuangan == '0'">Simpan</CButton>            
        </template>
    </CModal>
</template>

<script>
export default {
    name: 'modal-pengajuan-pembatalan',
    props: [
        'modalDetailPembatalan',
        'title',
        'formData'
    ],

    watch: {
        modalDetailPembatalan: function(val) {
            if(!this.modalDetailPembatalan) {                
                this.$emit('closeModalPembatalan', val)
            }            
        },        
    },

    methods: {
        postStatusPembatalan() {
            this.$parent.postStatusPembatalan(this.formData);
        },
        lihatFile(item) {
            this.$parent.lihatFileRefund(item);

        }
    },

    computed: {
        statusPembatalan: function() {
            if(this.formData.statusbatal === "Disetujui") {
                return 1;
            } else if(this.formData.statusbatal === "Ditolak") {
                return 2;
            } else {
                return 0;
            }
        }
    }
}
</script>

<style>
    table tr th, table tr td {
        border: 0 !important;
    }
</style>